export default "__VITE_ASSET__BcDBmvL5__"